import { Component, Inject, Injector, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedConstants } from '../../common';
import { RoutingService } from '../../helper';
import { PaginationFilter } from '../../interfaces';
import { BaseConfirmationComponent } from '../base-confirmation-component/base-confirmation-component';

@Component({
  standalone: true,
  selector: 'app-base-paginator-component',
  template: ``,
})
export class BasePaginatorComponent extends BaseConfirmationComponent {
  @Input() pageIndex: number = 0;
  @Input() pageSize: number = SharedConstants.DEFAULT_PAGE_SIZE;
  constructor(
    @Inject(String) protected override translationArr: string[] = [],
    protected override injector: Injector = null
  ) {
    super(translationArr, injector);
  }

  // protected
  protected getPaginatorConfigsFromURL(): void {
    const queries: string[] = this.injector
      .get(RoutingService)
      .getQueryParamsFromUrl(this.injector.get(ActivatedRoute), ['page', 'pageSize']);
    this.pageIndex = +queries[0];
    this.pageSize = +queries[1] > 0 ? +queries[1] : SharedConstants.DEFAULT_PAGE_SIZE;
  }
  protected setPaginatorConfigsFromURL(): void {
    this.injector.get(RoutingService).setQueryParamsInUrl([
      { key: 'page', value: this.pageIndex },
      { key: 'pageSize', value: this.pageSize },
    ]);
  }

  protected getPaginationFilter(paginationFilter: PaginationFilter): void {
    this.pageIndex = paginationFilter.pageIndex;
    this.pageSize = paginationFilter.pageSize;
  }
  
  protected resetPaginator(): void {
    this.pageIndex = 0;
    this.pageSize = this.pageSize ? this.pageSize : SharedConstants.DEFAULT_PAGE_SIZE;
    this.setPaginatorConfigsFromURL();
  }
}
